<template>
<div class="assessment-list">
<div class="container-fluid">
  <div class="table-responsive margin-Top-6Perc overflowXHidden">
    <table class="table table-striped">
      <thead>
        <tr>
          <th class="text-align-center font-size-15px border-right">Type</th>
          <th class="text-align-center font-size-15px border-right">Title</th>
          <th class="text-align-center font-size-15px border-right">Sub-Title</th>
          <th class="text-align-center font-size-15px border-right">Created TS</th>
          <th class="text-align-center font-size-15px border-right">Updated TS</th>
          <th class="text-align-center font-size-15px">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="assessmentObj in getCombinedList" :key="assessmentObj.AssessmentId" v-bind:assessmentObj="assessmentObj" >
          
          <td class="border-right text-align-center col-lg-1">{{!has(assessmentObj, 'CourseMasterId') ? getAssessmentType(assessmentObj.AssessmentType) : 'Recommendation Assessment'}}</td>
          <td class="border-right text-align-center col-lg-4">{{!has(assessmentObj, 'CourseMasterId') ? assessmentObj.AssessmentTitle : assessmentObj.CourseTitle}}</td>
          <td class="border-right text-align-center col-lg-3">{{!has(assessmentObj, 'CourseMasterId') ? assessmentObj.AssessmentSubTitle : assessmentObj.SubTitle}}</td>
          <td class="border-right text-align-center col-lg-1">{{formatAndShowDate(assessmentObj.CreatedTS)}}</td>
          <td class="border-right text-align-center col-lg-1">{{formatAndShowDate(assessmentObj.UpdatedTS)}}</td>

          <td v-if="!has(assessmentObj, 'CourseMasterId')" class="border-right text-align-center col-lg-2">
            <a class="cursor-pointer" @click="performClickOperation($event,'view_assessment', assessmentObj)"> View  </a>|
            <a class="cursor-pointer" @click="performClickOperation($event,'update_assessment', assessmentObj)"> Edit  </a>|
            <a class="cursor-pointer" @click="performClickOperation($event,'delete_assessment', assessmentObj)"> Delete </a>|
            <a class="cursor-pointer" @click="performClickOperation($event,'copy_assessment', assessmentObj)"> Copy Assessment </a>|
            <a class="cursor-pointer" @click="performClickOperation($event,'view_journey', assessmentObj)"> View Journey</a>
          </td>
          <td v-else class="border-right text-align-center col-lg-2">
            <a class="cursor-pointer" @click="performClickOperation($event,'view_recommendation_assessment', assessmentObj)"> View  </a>|
            <a class="cursor-pointer" @click="performClickOperation($event,'update_recommendation_assessment', assessmentObj)"> Edit  </a>|
            <a class="cursor-pointer" @click="performClickOperation($event,'delete_recommendation_assessment', assessmentObj)"> Delete </a>|
            <a class="cursor-pointer" @click="performClickOperation($event,'copy_recommendation_assessment', assessmentObj)"> Copy Assessment </a>|
            <a class="cursor-pointer"
              @click="openRecommendationAssCourse(`/assessmentjourney?courseId=${assessmentObj.CourseMasterId}`, assessmentObj)">
              View Journey
            </a>
          </td>
        </tr>
      </tbody>
    </table>
    </div>
  </div>
  <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixDeleteAssessmentString" v-bind:postfixString="postDeleteAssessmentString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="userConfirmation"></confirmation-alert>
  <view-assessment-overlay v-if="showViewAssessmentOverlay" :selectedAssessmentObj="getSelectedAssessmentObj" @closeOverlay="CloseCurrentOpenAssessmentOverlay"></view-assessment-overlay>
  <update-assessment-overlay v-if="showUpdateAssessmentOverlay" :selectedAssessmentObj="getSelectedAssessmentObj" @closeOverlay="CloseCurrentOpenAssessmentOverlay"></update-assessment-overlay>
  <view-course-details v-if="showViewCourseDetails" v-bind:selectedCourseObj="getSelectedAssessmentObj" @closeViewCourse="updateShowViewCourseDetailsFlag" :isComingFrom="constants.CourseSearchBarEnum.AssessmentJourney"></view-course-details>
  <edit-course-details @showSpinner="updateShowSpinnerFlag" v-if="showEditCourseDetails" v-bind:selectedCourseObj="getSelectedAssessmentObj" @closeEditCourse="updateShowEditCourseDetailsFlag" :isComingFrom="constants.CourseSearchBarEnum.AssessmentJourney"></edit-course-details>
  <!-- Show Spinner -->
  <div class="animationload" v-show="showSpinner">
    <div class="osahanloading"></div>
  </div>
  <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
  <loader></loader>
</div>
</template>
<script>
import ViewCourseDetailsOverlay from '@/components/ViewCourseDetailOverlay'
import UpdateAssessmentOverlay from '@/components/assessments/UpdateAssessmentOverlay'
import ViewAssessmentOverlay from '@/components/assessments/ViewAssessmentOverlay'
import AlertBox from '@/components/AlertOverlay'
import { courseService } from '@/server-util/course-service'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import { assessmentService } from '@/server-util/assessment-service'
import Loader from '@/components/dashboard/Loader'
import findIndex from 'lodash/findIndex'
import EditCourseDetailsOverlay from '@/components/EditCourseDetailOverlay'
import filter from 'lodash/filter'
import has from 'lodash/has'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import { constants } from '../../utils/constants'
export default {
  props: ['combinedList'],
  data: function () {
    return {
      constants: constants,
      showViewAssessmentOverlay: false,
      showUpdateAssessmentOverlay: false,
      selectedAssessmentObj: null,
      showSpinner: false,
      showAlertDialog: false,
      errorMsg: '',
      prefixDeleteAssessmentString: '',
      postDeleteAssessmentString: '',
      showConfirmationBox: false,
      selectedOperation: '',
      showViewCourseDetails: false,
      showEditCourseDetails: false
    }
  },
  name: 'assessment-list',
  methods: {
    updateShowSpinnerFlag (value) {
      this.$store.state.isLoading = value
    },
    updateShowEditCourseDetailsFlag (value) {
      // AK: Used to close the Edit Course Overlay
      this.showEditCourseDetails = value
      let currObjIndex = findIndex(this.getCombinedList, (obj) => {
        return has(obj, 'CourseMasterId') && obj.CourseMasterId === this.getSelectedAssessmentObj.CourseMasterId
      })
      let currObjIndexInGlobalRecAssessmentList = findIndex(this.getRecAssessmentListFromState, (obj) => {
        return obj.CourseMasterId === this.getSelectedAssessmentObj.CourseMasterId
      })
      // console.log('currObjIndexInGlobalRecAssessmentList: ' + currObjIndexInGlobalRecAssessmentList + ' currObjIndex: ' + currObjIndex)
      // AK: Update current Rec assessment course object into combined list as well
      if (currObjIndexInGlobalRecAssessmentList !== -1 && currObjIndex !== -1) {
        this.getCombinedList[currObjIndex] = this.getRecAssessmentListFromState[currObjIndexInGlobalRecAssessmentList]
      }
      var objToReturn = {
        assessmentList: this.getAssessmentListFromState,
        recAssessmentList: this.getRecAssessmentListFromState,
        combinedList: this.getCombinedList
      }
      this.$emit('updatedAssessmentList', objToReturn)
    },
    updateShowViewCourseDetailsFlag (value) {
      // AK: Used to close the View Course Overlay
      this.showViewCourseDetails = value
      this.$store.state.isOverlayVisible = false
    },
    openRecommendationAssCourse: function (pathToShow, currCourseObj) {
      localStorage.setItem('selectedMenu', constants.MenuOptionsEnum.Content)
      localStorage.setItem('selectedSubMenu', constants.SubMenuOptionsEnum.AssessmentJourney)
      this.$store.state.selectedCourseObjFromFilter = currCourseObj
      this.$store.state.hightLightOptionExplictly = true
      this.$router.push(pathToShow)
    },
    getAssessmentType: function (type) {
      var valueToReturn = ''
      switch (type) {
        default:
        case constants.AssessmentType.Personalization:
          valueToReturn = 'Personalization'
          break
        case constants.AssessmentType.PrePost:
          valueToReturn = 'Pre-Post'
          break
        case constants.AssessmentType.StandAlone:
          valueToReturn = 'Stand Alone'
          break
      }
      return valueToReturn
    },
    userConfirmation (value) {
      this.showConfirmationBox = false
      if (value) {
        switch (this.selectedOperation) {
          case 'delete_assessment':
            this.deleteSelectedAssessment()
            break
          case 'delete_recommendation_assessment':
            this.deleteCourseMaster()
            break
          case 'copy_recommendation_assessment':
            this.copyCourseMaster()
            break
          case 'copy_assessment':
            this.copyCurrentAssessment()
            break
        }
      }
    },
    copyCourseMaster: function () {
      var _this = this
      var storeObj = this.$store
      if (
        this.selectedAssessmentObj.CourseMasterId !== undefined &&
        this.selectedAssessmentObj !== null
      ) {
        this.$store.state.isLoading = true
        courseService
          .copyCourseMaster(storeObj.state.access_token, this.selectedAssessmentObj.CourseMasterId)
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              var tempCombinedList = _this.combinedList
              tempCombinedList.push(responseObj.data)
              var objToReturn = {
                assessmentList: this.getAssessmentListFromState,
                recAssessmentList: this.getRecAssessmentListFromState.push(responseObj.data),
                combinedList: tempCombinedList
              }
              _this.$emit('updatedAssessmentList', objToReturn)
              _this.$store.state.isLoading = false
              _this.isCurrentlyShowingSpinner = false
              _this.showAlertDialog = true
              _this.errorMsg = '\'' + this.selectedAssessmentObj.CourseTitle + '\' assessment copied successfully.'
              // console.log('Copy Course >>> ' + JSON.stringify(responseObj.data))
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              this.$store.state.isLoading = false
            }
          }, errorObj => {
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            this.errorMsg = errorObj.response.statusText
          })
      } else {
        console.log(
          'Selected COURSE Object is NULL hence declined DELETE COURSE OPERATION'
        )
      }
    },
    deleteCourseMaster: function () {
      var _this = this
      var storeObj = this.$store
      if (
        this.selectedAssessmentObj.CourseMasterId !== undefined &&
        this.selectedAssessmentObj !== null
      ) {
        this.$store.state.isLoading = true
        courseService
          .deleteCourseMaster(storeObj.state.access_token, this.selectedAssessmentObj.CourseMasterId)
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Refresh Course List
              _this.removeSelectedObjFromList()
              _this.$store.state.isLoading = false
              // console.log(JSON.stringify(responseObj.data))
            } else {
              _this.showAlertDialog = true
              _this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // this.showSpinner = false
              _this.$store.state.isLoading = false
            }
          }, errorObj => {
            // AK: Hide Spinner
            _this.$store.state.isLoading = false
            _this.showAlertDialog = true
            _this.errorMsg = errorObj.response.statusText
          })
      } else {
        console.log(
          'Selected COURSE Object is NULL hence declined DELETE COURSE OPERATION'
        )
      }
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button of delete element overlay
      this.showConfirmationBox = value
    },
    CloseCurrentOpenAssessmentOverlay (value) {
      const closeOverlay = value.closeOverlay
      const updatedObj = value.updatedObj
      if (updatedObj !== null) {
        // AK: Update it in assessment list.
        let currObjIndex = findIndex(this.getAssessmentListFromState, (obj) => {
          return obj.AssessmentId === updatedObj.AssessmentId
        })
        if (currObjIndex !== -1) {
          this.getAssessmentListFromState[currObjIndex] = updatedObj
        }
        // AK: Now update it in combined list as well.
        currObjIndex = findIndex(this.getCombinedList, (obj) => {
          return !has(obj, 'CourseMasterId') && obj.AssessmentId === updatedObj.AssessmentId
        })
        if (currObjIndex !== -1) {
          this.getCombinedList[currObjIndex] = updatedObj
        }
        var objToReturn = {
          assessmentList: this.getAssessmentListFromState,
          recAssessmentList: this.getRecAssessmentListFromState,
          combinedList: this.getCombinedList
        }
        this.$emit('updatedAssessmentList', objToReturn)
      }
      this.showViewAssessmentOverlay = !closeOverlay
      this.showUpdateAssessmentOverlay = !closeOverlay
      // AK: Enable Background Scrolling
      this.$store.state.isOverlayVisible = !closeOverlay
    },
    formatAndShowDate: function (date) {
      var dateToPass = date
      if (dateToPass !== undefined && dateToPass.indexOf('Z') === -1) {
        dateToPass += 'Z'
      }
      return dmAdminUtils.covertUtcToEst(dateToPass)
    },
    performClickOperation: function (event, selectedOperation, selectedObj) {
      this.selectedAssessmentObj = selectedObj
      this.selectedOperation = selectedOperation
      // console.log(JSON.stringify(this.selectedAssessmentObj))
      switch (selectedOperation) {
        case 'view_recommendation_assessment':
          this.showViewCourseDetails = true
          this.$store.state.isOverlayVisible = true
          break
        case 'update_recommendation_assessment':
          this.showEditCourseDetails = true
          this.$store.state.isOverlayVisible = true
          break
        case 'copy_assessment':
          this.showConfirmationBox = true
          this.prefixDeleteAssessmentString = 'Are you sure you want copy '
          this.postDeleteAssessmentString = '\'' + this.selectedAssessmentObj.AssessmentTitle + '\' assessment?'
          break
        case 'view_journey':
          localStorage.setItem('selectedMenu', constants.MenuOptionsEnum.Content)
          localStorage.setItem('selectedSubMenu', constants.SubMenuOptionsEnum.AssessmentJourney)
          this.$store.state.selectedAssessmentObjFromFilter = this.selectedAssessmentObj
          this.$store.state.hightLightOptionExplictly = true
          this.$router.push('/assessmentjourney?assessmentId=' + this.selectedAssessmentObj.AssessmentId)
          break
        case 'view_assessment':
          this.showViewAssessmentOverlay = true
          // AK: Disable Background Scrolling
          this.$store.state.isOverlayVisible = true
          break
        case 'update_assessment':
          this.showUpdateAssessmentOverlay = true
          // AK: Disable Background Scrolling
          this.$store.state.isOverlayVisible = true
          break
        case 'delete_assessment':
          this.showConfirmationBox = true
          this.prefixDeleteAssessmentString = 'Are you sure you want delete '
          this.postDeleteAssessmentString = '\'' + this.selectedAssessmentObj.AssessmentTitle + '\' assessment?'
          break
        case 'delete_recommendation_assessment':
          this.showConfirmationBox = true
          this.prefixDeleteAssessmentString = 'Are you sure you want delete '
          this.postDeleteAssessmentString = '\'' + this.selectedAssessmentObj.CourseTitle + '\' assessment?'
          break
        case 'copy_recommendation_assessment':
          this.showConfirmationBox = true
          this.prefixDeleteAssessmentString = 'Are you sure you want copy '
          this.postDeleteAssessmentString = '\'' + this.selectedAssessmentObj.CourseTitle + '\' assessment?'
          break
      }
    },
    deleteSelectedAssessment: function () {
      var storeObj = this.$store
      var _this = this
      if (
        this.selectedAssessmentObj.AssessmentId !== undefined &&
        this.selectedAssessmentObj.AssessmentId !== null &&
        this.selectedAssessmentObj.AssessmentId !== 'null'
      ) {
        // _this.showSpinner = true
        _this.$store.state.isLoading = true
        assessmentService
          .deleteAssessment(
            storeObj.state.access_token,
            this.selectedAssessmentObj.AssessmentId
          )
          .then(
            responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                // AK: Remove selected assessment object
                _this.removeSelectedObjFromList()
                _this.$store.state.isLoading = false
              } else {
                _this.showAlertDialog = true
                _this.errorMsg =
                  'Oops! Something went wrong. Please try again.'
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
              }
            },
            errorObj => {
              // AK: Hide Spinner
              // this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = errorObj.response.data.statusText
            }
          )
      } else {
        console.log(
          'AssessmentId is NULL hence declined DELETE ASSESSMENT OPERATION'
        )
      }
    },
    copyCurrentAssessment: function () {
      var storeObj = this.$store
      var _this = this
      if (
        this.selectedAssessmentObj.AssessmentId !== undefined &&
        this.selectedAssessmentObj.AssessmentId !== null &&
        this.selectedAssessmentObj.AssessmentId !== 'null'
      ) {
        // _this.showSpinner = true
        _this.$store.state.isLoading = true
        assessmentService
          .copyAssessment(
            storeObj.state.access_token,
            this.selectedAssessmentObj.AssessmentId
          )
          .then(
            responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                // AK: Add newly created assessment object into list
                _this.$store.state.assessmentList.push(responseObj.data)
                var tempCombinedList = _this.combinedList
                tempCombinedList.push(responseObj.data)
                var objToReturn = {
                  assessmentList: _this.getAssessmentListFromState,
                  recAssessmentList: this.getRecAssessmentListFromState,
                  combinedList: tempCombinedList
                }
                this.$emit('updatedAssessmentList', objToReturn)
                _this.$store.state.isLoading = false
              } else {
                _this.showAlertDialog = true
                _this.errorMsg =
                  'Oops! Something went wrong. Please try again.'
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
              }
            },
            errorObj => {
              // AK: Hide Spinner
              // this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = errorObj.response.data.statusText
            }
          )
      } else {
        console.log(
          'AssessmentId is NULL hence declined COPY ASSESSMENT OPERATION'
        )
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    removeSelectedObjFromList: function () {
      var objToReturn = {
        assessmentList: [],
        recAssessmentList: [],
        combinedList: []
      }
      if (this.selectedOperation === 'delete_assessment') {
        objToReturn.assessmentList = filter(this.getAssessmentListFromState, (obj) => {
          return this.selectedAssessmentObj.AssessmentId !== obj.AssessmentId
        })
        objToReturn.combinedList = filter(this.getCombinedList, (obj) => {
          return this.selectedAssessmentObj.AssessmentId !== obj.AssessmentId
        })
        objToReturn.recAssessmentList = this.getRecAssessmentListFromState
      } else {
        objToReturn.assessmentList = this.getAssessmentListFromState
        objToReturn.combinedList = filter(this.getCombinedList, (obj) => {
          return this.selectedAssessmentObj.CourseMasterId !== obj.CourseMasterId
        })
        objToReturn.recAssessmentList = filter(this.getRecAssessmentListFromState, (obj) => {
          return this.selectedAssessmentObj.CourseMasterId !== obj.CourseMasterId
        })
      }
      this.$emit('updatedAssessmentList', objToReturn)
    },
    has: function (object, path) {
      return has(object, path)
    }
  },
  components: {
    'view-course-details': ViewCourseDetailsOverlay,
    'confirmation-alert': ConfirmationOverlay,
    'update-assessment-overlay': UpdateAssessmentOverlay,
    'view-assessment-overlay': ViewAssessmentOverlay,
    'alert-box': AlertBox,
    'edit-course-details': EditCourseDetailsOverlay,
    'loader': Loader
  },
  computed: {
    getCombinedList: {
      get: function () {
        return this.combinedList
      },
      set: function (newValue) {
        this.combinedList = newValue
      }
    },
    getSelectedAssessmentObj: {
      get: function () {
        return this.selectedAssessmentObj
      }
    },
    getAssessmentListFromState: {
      get: function () {
        return this.$store.state.assessmentList
      },
      set: function (newValue) {
        this.$store.state.assessmentList = newValue
      }
    },
    getRecAssessmentListFromState: {
      get: function () {
        return this.$store.state.recAssessmentList
      },
      set: function (newValue) {
        this.$store.state.recAssessmentList = newValue
      }
    }
  }
}
</script>
<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.text-align-left {
  text-align: left;
}
.margin-Top-1Perc {
  margin-top: 1%;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.margin-Top-3Perc {
  margin-top: 3%;
}
.margin-Top-6Perc {
  margin-top: 6%;
}
.margin-left-1Perc {
  margin-left: 1%;
}
.margin-left-2Perc {
  margin-left: 2%;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.overflow-x-hidden {
  overflow-x: hidden !important;
}
.assessment-list {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding-left: inherit;
  padding-right: inherit;
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
.table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
}
.border-right {
  border-right: 1px solid #aaa !important;
}
.text-align-center {
  text-align: center !important;
}
.font-size-15px {
  font-size: 15px !important;
}
a:link {
  color: #2c3e50;
}
a:visited {
  color: #2c3e50;
}
a:hover {
  color: #2c3e50;
}
a:active {
  color: #2c3e50;
}
.btn-text-color {
  color: #2c3e50;
}
.cursor-pointer {
  cursor: pointer;
}
.text-decoration-underline {
  text-decoration: underline;
}
.table>thead>tr>th {
    vertical-align: bottom;
    border-bottom: 0px solid #aaaaaa;
}
.text-align-center{
  text-align: center !important;
}

a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a{
  color: #2c3e50 !important;
}
.overflowXHidden {
  overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/assessments/AssessmentList.vue